import {apiGet, apiPost, apiPostWithRetry} from './client';

export function generateText({celebId, concept, details}) {
    return apiPostWithRetry('/celebs/generate-text', {
        celeb_id: celebId,
        concept,
        details,
    });
}

export function createVideoGeneration({celebId, wishText, accountId, useCredits = true}) {
    return apiPost('/celebs/generate', {
        celeb_id: celebId,
        wish_text: wishText,
        account_id: accountId,
        use_credits: useCredits,
    });
}

export function getGenerationStatus(jobId) {
    return apiGet(`/celebs/generate/${jobId}`);
}
